export default "__VITE_ASSET__BArvAjCT__"